import { render, staticRenderFns } from "./ReportArchiveButton.vue?vue&type=template&id=6cb311be"
import script from "./ReportArchiveButton.vue?vue&type=script&lang=js"
export * from "./ReportArchiveButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports